var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconVisibility48Line = function SvgIconVisibility48Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 35.2c-8.25 0-13.4-5.21-15.47-10.08-.31-.72-.31-1.52 0-2.25C10.6 18 15.74 12.79 24 12.79c10.38 0 14.47 7.71 15.47 10.08.31.72.31 1.52 0 2.24-1 2.37-5.09 10.08-15.47 10.08v.01ZM11.75 24c.93 2.08 4.23 7.8 12.25 7.8s11.32-5.72 12.25-7.8c-.93-2.08-4.23-7.8-12.25-7.8S12.68 21.92 11.75 24Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 30.7c-3.69 0-6.7-3.01-6.7-6.7 0-3.69 3.01-6.7 6.7-6.7 3.69 0 6.7 3.01 6.7 6.7 0 3.69-3.01 6.7-6.7 6.7Zm0-10c-1.82 0-3.3 1.48-3.3 3.3 0 1.82 1.48 3.3 3.3 3.3 1.82 0 3.3-1.48 3.3-3.3 0-1.82-1.48-3.3-3.3-3.3Z",
    fill: "current"
  })));
};
export default SvgIconVisibility48Line;